<template>
  <div class="address-item dropdown-item">
    <div class="clearfix">
      <div class="float-left">
        <h6 class="h6 address-title">
          {{ item.name }}<i v-if="item.customer_code">&nbsp;({{ item.customer_code }})</i>
        </h6>
      </div>

      <div class="address-services float-left">
        <div
          v-if="item.has_forklift"
          class="address-service d-inline text-muted"
          v-tooltip:bottom="'Has a forklift'"
        >
          <span class="icon">
              <svg>
                  <use xlink:href="/images/icons.svg#ui-lift"></use>
              </svg>
          </span>
        </div>
        <div
          v-else
          class="address-service d-inline text-muted"
          v-tooltip:bottom="'No forklift, this may affect your pricing.'"
        >
          <span class="icon">
            <svg>
                <use xlink:href="/images/icons.svg#ui-lift-none"></use>
            </svg>
          </span>
        </div>
        <div
          v-if="item.linkedDPID"
          class="address-service d-inline text-muted"
          v-tooltip:bottom="'This is a Freighthub customer'"
        >
          <i class="fas fa-share-alt"></i>
        </div>
        <div
          v-if="item.wait_time"
          class="address-service d-inline text-muted"
          v-tooltip:bottom="'The average time a truck spends at this location when loading and unloading.'"
          :style="{ background: waittimeColour }"
        >
          <i class="far fa-clock"></i> {{ item.wait_time }}m
        </div>
        <div
          v-if="item.truck_density_band"
          class="address-service d-inline text-muted"
          v-tooltip:bottom="truckDensityHoverText"
        >
          <i v-if="item.truck_density_band == 1" class="far fa-building"></i>
          <i v-if="item.truck_density_band == 2" class="far fa-building"></i>
          <i v-if="item.truck_density_band == 3" class="far fa-home"></i>
          <i v-if="item.truck_density_band == 4" class="far fa-home"></i>
          <i v-if="item.truck_density_band == 5" class="far fa-building"></i>
          <i v-if="item.truck_density_band == 6" class="far fa-tree-alt"></i>
        </div>
      </div>

      <div class="address-services float-right">
        <div
          class="address-service d-inline text-muted"
          style="cursor:pointer;"
          v-tooltip:bottom="'Edit this location'"
          @click.stop="$emit('open-form', item)"
        >
          <i class="far fa-edit"></i>
        </div>
      </div>
    </div>
    <p class="address-location">
      {{ item.address.data.prefix || "" }}{{ item.address.data.street_number }}
      {{ item.address.data.street_name }}, {{ item.address.data.suburb }},
      {{ item.address.data.city }} {{ item.address.data.post_code }}
    </p>
    <p class="address-open">
      {{ item.opening_hours ? "Open " + item.opening_hours : "No opening hours set" }}
    </p>
  </div>
</template>

<script>
export default {
  name: "location-item",
  props: {
    item: {required: true},
  },
  data() {
    let colour;
    let waitTime = Number.parseInt(this.item.wait_time);
    if (waitTime > 20) {
      colour = "#ff8aa3";
    } else if (waitTime < 10) {
      colour = "#5cff7c";
    } else {
      colour = "#ffe978";
    }
    return {
      waittimeColour: colour,
    };
  },
  computed: {
    truckDensityHoverText() {
      var baseText = "This location is calculated to be ";
      switch (this.item.truck_density_band) {
        case 1:
          return baseText + "a high traffic area.";
        case 2:
          return baseText + "a high traffic area.";
        case 3:
          return baseText + "a medium traffic area.";
        case 4:
          return baseText + "a low traffic area.";
        case 5:
          return baseText + "a low traffic area.";
        default:
          return "Whether the location is urban or rural based on truck density in the area.";
      }
    },
  },
};
</script>
